import {
    RESORTEAR_JUEZ,
    RESORTEAR_JUEZ_SUCCESS,
    RESORTEAR_JUEZ_ERROR
} from '../types';

import Swal                                             from 'sweetalert2';
import clienteAxios                                     from '../config/axios';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_RESORTEO_SUCCESS }                         from '../constants/messages';



// RESORTEAR JUEZ
export default function resortearJuezAction(idAudiencia, ResorteoDto, handleClose)
{   return async (dispatch) => {
        dispatch( resortearJuez() );
        WaitingMessage('Cargando');
        try {
            const response = await clienteAxios.post(`/resortear-juez/${idAudiencia}`, ResorteoDto);
            dispatch( resortearJuezSuccess(response.data) );
            Swal.close();
            SuccessMessage(MSG_RESORTEO_SUCCESS);
            handleClose();
        }
        catch(error) {            
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            if(response){
                data = response.data;
            }
            dispatch( resortearJuezError(error) );
            ErrorMessage(data.message);    
        }
    }
}

const resortearJuez = () => ({
    type: RESORTEAR_JUEZ,
    payload: true
});

const resortearJuezSuccess = audience => ({
    type: RESORTEAR_JUEZ_SUCCESS,
    payload: audience
});

const resortearJuezError = error => ({
    type: RESORTEAR_JUEZ_ERROR,
    payload: error
});